import { FC } from 'react';
import styled from 'styled-components';
import type { Match } from '../../../../../types';

const BottomInfoTitleAndNotesMatch = styled.div`
width: 100%;
height: 30%;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;

& .title-match-space {
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 0px;

    & img.belt-img {
        height: 100%;
        object-fit: contain;
        object-position: center;
    }

    & .title-match {
        font-size: 5px;
        font-weight: 500;
        color: white;
        line-height: 1;
        margin: 0;
        padding: 0;

    }
}

& .notes-match {
    height: 40%;
    font-size: 10px;
    font-weight: 500;
    text-transform: uppercase;
    color: white;
}
`;

interface BottomInfoBeltAndNotesRenderingProps {
    matchInfo: Match;
}

const BottomInfoBeltAndNotesRendering: FC<BottomInfoBeltAndNotesRenderingProps> = ({ matchInfo }) => {
    return (
        <BottomInfoTitleAndNotesMatch className='bottom-info-belt-and-notes'>
            {matchInfo.belt && (
                <div className='title-match-space'>
                    <img
                        src={process.env.REACT_APP_STORAGE_URL + matchInfo.belt.img_path}
                        alt={matchInfo.belt.name}
                        className='belt-img'
                    />
                    <div className='title-match'>{matchInfo.belt.name}</div>
                </div>
            )}
            {matchInfo.notes && (
                <div className='notes-name'>{matchInfo.notes}</div>
            )}
        </BottomInfoTitleAndNotesMatch>
    )
}

export default BottomInfoBeltAndNotesRendering;
